<template>
    <b-sidebar id="sidebar-1" :visible="true" no-header :backdrop="false" :class="sidebarClass" sty>
        <b-button @click="$emit('toggle-sidebar')" variant="link" class="d-flex ms-auto p-0 mr-2 hsadow-none"
            id="toggleSidebar">
            <div class="animated-hamburger open">
                <span></span><span></span><span></span><span></span>
            </div>
        </b-button>
        <div class="overflow-auto">
            <div class="menu mt-1">
                <ul class="px-0 m-0" v-if="!isUnAuthorized">
                    <li>
                        <router-link :to="{ name: 'Dashboard' }" class="menu-item" v-if="!$global.hasRole('admin')">
                            <span class="menu-icon">
                                <b-icon :icon="`speedometer2`"></b-icon>
                            </span>
                            <span class="text">{{ this.$t('title.dashboard') }}</span>
                        </router-link>

                        <router-link :to="{ name: 'Dashboard' }" class="menu-item"
                            :class="{ active: $route.name === 'Dashboard' }" v-else>
                            <span class="menu-icon">
                                <b-icon :icon="`speedometer2`"></b-icon>
                            </span>
                            <span class="text">{{ this.$t('title.dashboard') }}</span>
                        </router-link>

                    </li>

                    <li v-for="item in _.filter(
                        menuItems,
                        i => !i.roles || (i.roles && _.includes(i.roles, user.role))
                    )" :key="item.id" @click="handleLinkClick">
                        <router-link :to="{ name: `${item.id}` }" class="menu-item">
                            <span class="menu-icon">
                                <b-icon :icon="item.icon"></b-icon>
                            </span>
                            <span class="text">{{ item.text }}</span>
                        </router-link>
                    </li>

                    <li v-if="this.isExpanded && $global.hasRole('admin')">
                        <b-button v-b-toggle.settings-collapse class="menu-item d-flex align-items-center"
                            variant="link">
                            <span class="menu-icon">
                                <b-icon :icon="'gear'" class=""></b-icon>
                            </span>
                            <span class="text">{{ this.$t('title.settings') }}</span>
                        </b-button>
                        <b-collapse id="settings-collapse" :visible="collapseOpen">
                            <ul class="submenu">
                                <li v-for="item in settingsItems" :key="item.id">
                                    <router-link :to="{ name: item.id }" class="menu-item">
                                        <span class="menu-icon">
                                            <b-icon :icon="item.icon"></b-icon>
                                        </span>
                                        <span class="text">{{ item.text }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </b-collapse>
                    </li>

                    <li v-if="!this.isExpanded">
                        <b-dropdown boundary="window"
                            :popper-opts="{ positionFixed: true, modifiers: { offset: '100%' } }"
                            class="submenu-dropdown">
                            <template #button-content>
                                <span class="menu-icon">
                                    <b-icon :icon="'gear'"></b-icon>
                                </span>
                            </template>
                            <b-dropdown-item v-for="item in submenuItems" :key="item.name" :to="{ name: item.name }"
                                class="menu-item-submenu">
                                <span class="menu-icon">
                                    <b-icon :icon="item.icon"></b-icon>
                                </span>
                                <span class="text">{{ item.text }}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </li>
                </ul>
            </div>
            <!-- <div class="my-1">
            <hr class="m-0 opacity-50" />
        </div> -->
            <!-- <div class="menu">
            <ul class="px-0">
                <li v-for="item in menuItems2" :key="item.id" @click="handleLinkClick">
                    <router-link :to="{ name: `${item.id}` }" class="menu-item">
                        <span class="menu-icon">
                            <b-icon :icon="item.icon"></b-icon>
                        </span>
                        <span class="text">{{ item.text }}</span>
                    </router-link>
                </li>
            </ul>
        </div> -->
        </div>
    </b-sidebar>
</template>

<script>
import {
    BButton,
    BSidebar,
    BIcon
} from 'bootstrap-vue';
import {
    mapGetters,
    mapState
} from 'vuex';

export default {
    components: {
        BButton,
        BSidebar,
        BIcon,
    },
    data() {
        return {
            collapseOpen: false,
            currentRoute: null,
            submenuItems:null
        };
    },
    props: {
        isExpanded: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        menuItems() {
            return [
                {
                    id: 'Integrations',
                    text: this.$t('title.Integrations'),
                    icon: 'building',
                    roles: ['admin']
                },
                {
                    id: 'ChatAi',
                    text: this.$t('title.rakoonChat'),
                    icon: 'chat-fill',
                    roles: ['admin']
                },
                {
                    id: 'scheduledTasks',
                    text: this.$t('title.Insights'),
                    icon: 'clock',
                    roles: ['admin']
                },
                {
                    id: 'statistics',
                    text: this.$t('title.statistics'),
                    icon: 'bar-chart',
                    roles: ['admin']

                },
            ];
        },
        settingsItems() {
            return [

                {
                    id: 'ApiLogs',
                    text: this.$t('title.ApiLogs'),
                    icon: 'file-earmark-text',
                    roles: ['admin']
                },
                {
                    id: 'Users',
                    text: this.$t('title.Users'),
                    icon: 'person',
                    roles: ['admin']
                },
                {
                    id: 'AuditTrail',
                    text: this.$t('title.userHistory'),
                    icon: 'clock-history',
                    roles: ['admin']

                },

            ];

        },
        menuItems2() {
            return [{
                id: 'instructions-menu',
                text: this.$t('title.instructions'),
                icon: 'info-circle'
            },
            {
                id: 'regulations-menu',
                text: this.$t('title.regulations'),
                icon: 'file-earmark-medical',
            },
            {
                id: 'accessibility-menu',
                text: this.$t('title.accessibilityStatement'),
                icon: 'file-richtext',
            },
            ];
        },
        sidebarClass() {
            return this.isExpanded ?
                'custom-sidebar full-width d-flex' :
                'small-width custom-sidebar d-flex';
        },
        ...mapState(['isUnAuthorized', 'user']),
    },
    methods: {
        toggleSidebar() {
            this.$emit('toggle-sidebar');
        },
        handleLinkClick() {
            if (window.innerWidth <= 768) {
                this.$emit('toggle-sidebar');
            }
        },
        checkActiveRoute() {
            // Ensure we have valid strings for path and route name
            const currentPath = (this.$route && this.$route.path) ? this.$route.path : "";
            const currentRouteName = (this.$route && this.$route.name) ? this.$route.name : "";

            const activeRoute = this.settingsItems.some(item => {
                return currentPath === item.id || currentRouteName === item.id;
            });

            this.collapseOpen = activeRoute;
        },
    },
    mounted() {
        const savedState = localStorage.getItem('settingsCollapseOpen');
        if (savedState !== null) {
            this.collapseOpen = JSON.parse(savedState);
        }

        this.checkActiveRoute();
    },
    watch: {
        collapseOpen(newState) {
            localStorage.setItem('settingsCollapseOpen', JSON.stringify(newState));
        },
        '$route'(to, from) {
            this.checkActiveRoute();
        },
    },
};
</script>
